<template>
  <el-drawer
    :title="$t('Product.TSL')"
    :visible.sync="visible"
    direction="rtl"
    size="600px"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :before-close="close"
  >
    <div class="drawer-content">
      <div class="drawer__content-main" style="padding: 18px 48px;">
        <code>
          <pre>{{ tslData }}</pre>
        </code>
      </div>
      <div class="drawer-footer" v-if="exportRole">
        <hl-button @click="hadnleExport" :loading="loading">{{
          $t('Common.exportData')
        }}</hl-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { getRoleByOperationCode } from '@/authorized'
import { downloadFile } from '@/utils/download'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    roleChildList: {
      type: Array
    }
  },
  data() {
    return {
      tslData: null,
      loading: false
    }
  },
  created() {
    this.getTslDetail()
  },
  computed: {
    // 导出
    exportRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'export')
      return val ? val.isPermission === 'Y' : false
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    getTslDetail() {
      const params = {
        id: this.id
      }
      this.$ajax
        .get(this.$api.product.product_tsl_detail, params)
        .then((res) => {
          this.tslData = res.data
        })
        .catch(() => {})
    },
    async hadnleExport() {
      this.loading = true

      const params = {
        id: this.id
      }

      this.$ajax
        .download(this.$api.product.product_tsl_export, params)
        .then((res) => {
          downloadFile(res)
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
